import {Component, EventEmitter, Output} from '@angular/core';
import {PresentationModeEnum} from '@core/enums/presentation-mode.enum';

@Component({
    selector: 'app-wizard-presentation-mode',
    templateUrl: './wizard-presentation-mode.component.html',
    styleUrls: ['./wizard-presentation-mode.component.scss']
})
export class WizardPresentationModeComponent {

    @Output() nextStepEvent: EventEmitter<PresentationModeEnum> = new EventEmitter();

    presentationModeText = PresentationModeEnum.TEXT;
    presentationModeVoice = PresentationModeEnum.VOICE;

    nextStepClick(mode: PresentationModeEnum): void {
        this.nextStepEvent.emit(mode);
    }
}
